import "../style/style.less";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import * as Sentry from "@sentry/react";
import { SnackbarProvider } from "notistack";
import React, { useEffect } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useSelector } from "react-redux";

import type { RootState } from "../store/state/rootReducer";
import theme from "../theme/theme";
import { AbilityContext } from "../contexts/AbilityContext";
import { ability, fetchCapabilities } from "../hooks/usePermissions";

import ModalsContainer from "./modals/ModalsContainer";
import Notifier from "./utils/notifier";
import AppRoutes from "./routes";
import { UiUpdatesAnnouncement } from "./featureAnnouncements/UiUpdatesAnnouncement";

const muiCache = createCache({
  key: "mui",
  prepend: true,
});

// Organization of Routes
function App() {
  const authenticated = useSelector((state: RootState) => state.auth.authenticated);

  useEffect(() => {
    if (authenticated) {
      fetchCapabilities();
    } else {
      ability.update([]);
    }
  }, [authenticated]);

  return (
    <AbilityContext.Provider value={ability}>
      <CacheProvider value={muiCache}>
        <MuiThemeProvider theme={theme}>
          <SnackbarProvider autoHideDuration={3000}>
            <DndProvider backend={HTML5Backend}>
              <Notifier />
              <AppRoutes />
              <ModalsContainer />
              <UiUpdatesAnnouncement />
            </DndProvider>
          </SnackbarProvider>
        </MuiThemeProvider>
      </CacheProvider>
    </AbilityContext.Provider>
  );
}

export default Sentry.withProfiler(App);
